import { render, staticRenderFns } from "./ChatVoice.vue?vue&type=template&id=a7096470"
import script from "./ChatVoice.vue?vue&type=script&lang=js"
export * from "./ChatVoice.vue?vue&type=script&lang=js"
import style0 from "./ChatVoice.vue?vue&type=style&index=0&id=a7096470&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports